class StringHelperService {
  private static serviceInstance: StringHelperService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  public classifyFuelType(item: string): string {
    return item === 'Petrol' || item === 'Diesel' || item === 'Electric'
      ? item.toLowerCase()
      : 'hybrid';
  }

  public classifyString(item: string): string {
    return item
      .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, '$2')
      .replace(/(?!\w|\s)./g, '')
      .replace(/\s+/g, '-')
      .toLowerCase();
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const stringHelperService = StringHelperService.instance;
